export default __webpack_public_path__ + "static/media/pagination_left.a0daae33.svg";